import React, { ChangeEvent } from 'react';
import Checkbox from 'rc-checkbox';
import EditTextGrade from '../../edit-text-grade/edit-text-grade';
import CalenderCell from '../components/cells-item/calender-cell';
import ApproveIcon from '../../../assets/icons/status/check-circle-green.svg';
import { Cell, CelType } from '../data-table';

export const renderCell = (item: Cell) => {
  switch (item.type) {
    case CelType.REGULAR:
      return <div className={'grid-item-regular'}>{item.content}</div>;

    case CelType.INPUT:
      return (
        <div className={'grid-item-input'}>
          <input
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              item?.input?.onChange(e.target.value);
            }}
            placeholder={item.content ?? 'הזן כאן'}
          />
        </div>
      );

    case CelType.TEXT_COLOR_GREEN:
      return <div className={'grid-item-text-color-green'}>{item.content}</div>;

    case CelType.TEXT_COLOR_YELLOW:
      return (
        <div className={'grid-item-text-color-yellow'}>{item.content}</div>
      );

    case CelType.TEXT_COLOR_RED:
      return <div className={'grid-item-text-color-red'}>{item.content}</div>;

    case CelType.RED_BG:
      return (
        <div
          style={{
            backgroundColor: '#FFE5E6',
            borderRadius: '4px',
            color: '#EC3024',
            display: 'inline-block',
            padding: '7px',
            textAlign: 'center',
            ...(item ? item.style : {}),
          }}
        >
          {item.content}
        </div>
      );

    case CelType.GREEN_BG:
      return (
        <div
          style={{
            backgroundColor: '#ECFEF6',
            borderRadius: '4px',
            color: '#022714',
            display: 'inline-block',
            padding: '7px',
            textAlign: 'center',
            ...(item ? item.style : {}),
          }}
        >
          {item.content}
        </div>
      );

    case CelType.YELLOW_BG:
      return (
        <div
          style={{
            backgroundColor: '#E1931D19',
            borderRadius: '4px',
            color: '#E1931D',
            display: 'inline-block',
            padding: '7px',
            textAlign: 'center',
            ...(item ? item.style : {}),
          }}
        >
          {item.content}
        </div>
      );

    case CelType.CHECK_BOX:
      return (
        <div className={'grid-item-checkbox'}>
          <Checkbox
            checked={item.checkBoxDefaultValue}
            onChange={(e) => {
              item.input &&
                item.input.onCheckBoxChange &&
                item.input.onCheckBoxChange(e.target.checked);
            }}
          />
          <div style={{ marginRight: '10px' }}>{item.content}</div>
        </div>
      );

    case CelType.APPROVE_ICON:
      return <img style={{ padding: '7px' }} src={ApproveIcon} />;

    case CelType.EDIT_TEXT_GRADE:
      return <EditTextGrade />;

    case CelType.CALENDAR:
      return <CalenderCell />;

    case CelType.BUTTON:
      return (
        <button
          {...(item.onClick && { onClick: item.onClick })}
          className={'grid-item-button'}
        >
          {item.content}
        </button>
      );

    default:
      return <div className={'grid-item-regular'}>{item.content}</div>;
  }
};
